export const advancedSetting = [
  { id: '1', label: 'Deemed Export' },
  { id: '2', label: 'Reverse Charge' },
  { id: '3', label: 'Forward Charge' },
  { id: '4', label: 'Unregister' },
];
